<template>
  <div class="cmp-settings-identities-project-details12345">
    <div v-if="invoiceProjectDetails && invoiceProjectDetails.invoice_project">
      <Dropdown2
        :label="$t('money_account_id')"
        :placeholder="$t('money_account_id')"
        :options="moneyAccountTV"
        :selected="
          moneyAccountTV.find(
            (c) =>
              c.value == invoiceProjectDetails.invoice_project.money_account_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('money_account_id', e)"
      />
      <MoneyAccountDetails
        v-if="selectedMoneyAccount"
        :moneyAccount="selectedMoneyAccount"
      />
      <TextField2
        id="due_days"
        :placeholder="$t('default_due_days')"
        :label="$t('default_due_days')"
        :value="invoiceProjectDetails.invoice_project.due_days"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        id="discount_days"
        :placeholder="$t('default_discount_days')"
        :label="$t('default_discount_days')"
        :value="invoiceProjectDetails.invoice_project.discount_days"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        id="discount_percent"
        :placeholder="$t('default_discount_percent')"
        :label="$t('default_discount_percent')"
        :value="invoiceProjectDetails.invoice_project.discount_percent"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <div class="ut-flex" style="border-bottom: 1px solid var(--sprt-5)">
        <TextField2
          id="vat_rate1"
          :cw="`80px`"
          :bb="'none'"
          :placeholder="$t('vat_rate1')"
          :label="$t('vat_rate1')"
          :value="invoiceProjectDetails.invoice_project.vat_rate1"
          :disabled="false"
          @blur="(e) => onTextFieldValueChange(e)"
        />
      </div>
      <div class="ut-flex" style="border-bottom: 1px solid var(--sprt-5)">
        <TextField2
          id="vat_rate2"
          :cw="`80px`"
          :bb="'none'"
          :placeholder="$t('vat_rate2')"
          :label="$t('vat_rate2')"
          :value="invoiceProjectDetails.invoice_project.vat_rate2"
          :disabled="false"
          @blur="(e) => onTextFieldValueChange(e)"
        />
      </div>
      <Dropdown2
        :label="$t('vat_type_shipping')"
        :placeholder="$t('vat_type_shipping')"
        :options="shippingVatTypeTV"
        :selected="
          shippingVatTypeTV.find(
            (c) =>
              c.value == invoiceProjectDetails.invoice_project.vat_type_shipping
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('vat_type_shipping', e)"
      />
      <Checkbox2
        :id="'end_of_period_flag'"
        :label="$t('end_of_period')"
        :value="invoiceProjectDetails.invoice_project.end_of_period_flag"
        :placeholder="$t('end_of_period')"
        @input="onEndOfPeriodClick"
      />
      <Dropdown2
        v-if="believe_special"
        :label="$t('legal_name')"
        :placeholder="$t('legal_name')"
        :options="legalNameTV"
        :selected="
          legalNameTV.find(
            (c) => c.value == invoiceProjectDetails.invoice_project.company_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('company_id', e)"
      />
      <!-- <Checkbox2
        :id="'royalty_flag'"
        :label="'Royalty Layout'"
        :value="invoiceProjectDetails.invoice_project.royalty_flag"
        :placeholder="'Royalty Layout'"
        @input="onRoyaltyFlagClick"
        bb="0px"
      /> -->
      <!-- <Dropdown2
        
        :label="$t('royalty_cost_group')"
        :placeholder="$t('royalty_cost_group')"
        :options="costGroupTV"
        :selected="
          costGroupTV.find(
            (c) => c.value == invoiceProjectDetails.invoice_project.cost_group_id_royalty
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('cost_group_id_royalty', e)"
        bb="0px"
      /> -->

      <Dropdown2
        v-if="believe_special"
        :label="$t('period_display')"
        :placeholder="$t('period_display')"
        :options="displayNameTV"
        :selected="
          legalNameTV.find(
            (c) => c.value == invoiceProjectDetails.invoice_project.blv_display
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('blv_display', e)"
        bb="0px"
      />
    </div>
  </div>
</template>
<script>
import { defaultTextFieldConfig } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createPaymentMethodTV } from "../../../../models/payment-method.model";
import { createMoneyAccountTV } from "../../../../models/money-account.model";
import { tv, createTV } from "../../../../models/text-value.model";
import InfoCard from "../../../../dt-plugins/info-card/info-card.vue";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import InvoiceForamatHints from "./general-invoice-format-hints";
import InvoiceForamatHintsLabel from "./general-invoice-format-hints-label";
import MoneyAccountDetails from "./general-money-account-details";

export default {
  components: {
    DTCheckbox,
    InfoCard,
    MoneyAccountDetails,
  },
  data() {
    return {
      textFieldConfig: defaultTextFieldConfig(),
      invoiceForamatHintsComp: InvoiceForamatHints,
      invoiceForamatHintsLabelComp: InvoiceForamatHintsLabel,
    };
  },
  props: {
    invoiceProjectDetails: {
      required: true,
    },
  },
  computed: {
    believe_special() {
      return this.$store.getters.account.believe_special;
    },
    costGroupTV: function () {
      return createTV(
        this.invoiceProjectDetails?.cost_groups || [],
        "cost_group_name",
        "cost_group_id"
      );
    },
    countriesTV: function () {
      return this.invoiceProjectDetails
        ? createCountriesTV(this.invoiceProjectDetails.countries)
        : [];
    },
    currenciesTV: function () {
      return this.invoiceProjectDetails
        ? createCurrencyTV(this.invoiceProjectDetails.currencies)
        : [];
    },
    paymentMethodTV: function () {
      return this.invoiceProjectDetails
        ? createPaymentMethodTV(this.invoiceProjectDetails.payment_methods)
        : [];
    },
    moneyAccountTV: function () {
      return this.invoiceProjectDetails
        ? createMoneyAccountTV(this.invoiceProjectDetails.money_accounts)
        : [];
    },
    shippingVatTypeTV: function () {
      return createTV(
        this.invoiceProjectDetails?.vat_types,
        "vat_type_name",
        "vat_type_id"
      );
    },
    legalNameTV: function () {
      return createTV(
        this.invoiceProjectDetails?.companies,
        "company_name",
        "company_id"
      );
    },
    displayNameTV: function () {
      const options = [{ value: "html", text: "html" }];
      return createTV(options, "text", "value");
    },
    disabled_paypal: function () {
      let email = this.invoiceProjectDetails?.invoice_project?.paypal_email;
      email = email ? email.trim() : "";
      return email.length > 0 ? true : false;
    },
    selectedMoneyAccount: function () {
      const moneyAccounts = this.invoiceProjectDetails?.money_accounts || [];
      const selected_money_account_id =
        this.invoiceProjectDetails?.invoice_project?.money_account_id || 0;
      console.log(
        "money",
        moneyAccounts.find(
          (row) => row.money_account_id == selected_money_account_id
        )
      );
      return moneyAccounts.find(
        (row) => row.money_account_id == selected_money_account_id
      );
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onEndOfPeriodClick: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value === true ? "1" : "0",
      });
    },
    onRoyaltyFlagClick: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value === true ? "1" : "0",
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-identities-project-details12345 {
  .dropdown-2 {
    label {
      width: 150px !important;
    }
  }
  .fc2 {
    label {
      &.fc2-label {
        width: 150px !important;
      }
    }
  }
  .invoice-format-container {
    display: flex;
    flex-direction: row;
    .field {
      flex: 1;
    }
    .icon {
      flex: 0.01;
      cursor: help;
    }
  }
}
</style>
